var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgInter = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF7A00"
  }), React.createElement("path", {
    d: "M6.69228 12H6.4113C6.06645 12 5.78546 12.2512 5.78546 12.6173V12.9622C5.78546 13.3283 6.06645 13.5795 6.4113 13.5795H6.69228C7.04777 13.5795 7.31812 13.3283 7.31812 12.9622V12.6173C7.31812 12.2491 7.04565 12 6.69228 12Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M11.4031 14.2032C10.5261 14.2032 9.97259 14.663 9.70012 15.1739L9.65755 14.3373H8.35266V19.7271H9.71076V16.7406C9.71076 15.8423 10.1918 15.3208 10.9113 15.3208C11.6308 15.3208 11.9246 15.7806 11.9246 16.6065V19.7293H13.2721V16.2616C13.2721 15.0483 12.7399 14.2032 11.4031 14.2032Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M5 15.4463H5.89831V19.7293H7.25641V14.3394H5V15.4463Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M20.2712 14.2032C18.5789 14.2032 17.5231 15.3208 17.5231 16.9598V17.0961C17.5231 18.7565 18.5576 19.8634 20.2712 19.8634C21.6612 19.8634 22.5894 19.1524 22.8512 18.0242H21.5037C21.3462 18.484 20.9609 18.8075 20.2712 18.8075C19.4559 18.8075 18.9855 18.3158 18.9131 17.3558H22.8831C22.9768 15.4889 22.0785 14.2032 20.2712 14.2032ZM18.945 16.4277C19.0706 15.6443 19.5091 15.2569 20.2606 15.2569C21.0226 15.2569 21.4207 15.6954 21.4931 16.4277H18.945Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M15.5796 18.0774V15.4463H16.9994V14.3394H15.5796V12.5109H14.2215V18.2136C14.2215 19.2993 14.8175 19.8634 16.0713 19.8634C16.3842 19.8634 16.7717 19.8102 17.0229 19.7271V18.6713C16.876 18.7245 16.6269 18.7863 16.3757 18.7863C15.7797 18.7884 15.5796 18.5691 15.5796 18.0774Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M26.685 14.2458C25.9016 14.2458 25.3482 14.7056 25.0863 15.3846L25.0544 14.3394H23.7495V19.7293H25.1076V17.0556C25.1076 16.0211 25.5781 15.4463 26.6126 15.4463C26.7488 15.4463 26.9042 15.457 27 15.4676V14.2777C26.9149 14.2564 26.7786 14.2458 26.685 14.2458Z",
    fill: "white"
  }));
};
export default SvgInter;